module.exports = [
  {
    "AgeGroup": "25-34 years",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 181.27
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 211.93
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 227.87
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 169.2
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 171.87
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 178.5
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 189.6
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 103.07
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 104.8
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 107.67
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 104.13
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 105.4
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 118.03
  },
  {
    "AgeGroup": "25-34 years",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 130.8
  }
]
